<template>
  <page-scaffold>
    <card-content :is-loading="isLoading" name="Уведомления" style="overflow-y: hidden">
      <div style="padding: 24px">
        <item-notification v-for="notification in notifications"
                           :key="notification.id"
                           :notification="notification"
                           @open-media="onOpenMedia"/>

      </div>
    </card-content>
    <media-viewer
        :visible="mediaViewerVisible"
        :type="mediaViewerType"
        :url="mediaViewerUrl"
        @close="mediaViewerVisible = false"/>
  </page-scaffold>

</template>

<script>
import PageScaffold from "./page-scaffold";
import CardContent from "./card-content";
import ItemNotification from "./item-notification";
import MediaViewer from "./media-viewer";
import axios from "axios";

export default {
  name: "page-notifications",
  data: () => {
    return {
      isLoading: true,
      notifications: [],
      mediaViewerVisible: false,
      mediaViewerType: null,
      mediaViewerUrl: ''
    }
  },
  components: {MediaViewer, ItemNotification, CardContent, PageScaffold},
  mounted() {
    this.isLoading = true
    axios({
      method: "GET",
      url: "v1/notifications",
      headers: {Authorization: `Bearer ` + localStorage.token},
    }).then(response => {
      this.isLoading = false
      this.notifications = response.data
    })
  },
  methods: {
    onOpenMedia(notification) {
      this.mediaViewerType = notification.type;
      this.mediaViewerUrl = notification.url;
      this.mediaViewerVisible = true;
    }
  }
}
</script>

<style scoped>


</style>
